import { createApp } from 'vue'
import App from '~/App.vue'
import {
  router,
  pinia,
  i18n,
  interceptors,
  toast,
  toastOptions,
  surveyPlugin,
  vSelect,
  vModal,
  contextmenu,
  loadingPlugin,
  apexCharts,
} from './plugins'
import { laravelEcho, pusher } from './providers'
import { registerCrossTabLogoutListener } from '~/services/auth/crossTabLogout'
import 'vue-loading-overlay/dist/css/index.css'

// Create app instance
export const app = createApp(App)

/**
 * Initialize app with async i18n
 */
async function initializeApp() {
  // Wait for i18n to be initialized
  const i18nInstance = await i18n

  /**
   * Register plugins
   */
  app.use(toast, toastOptions)
  app.use(pinia)
  app.use(router)
  app.use(i18nInstance)
  app.use(interceptors)
  app.use(vModal, {
    teleportTarget: '#modals',
  })
  app.use(surveyPlugin)
  app.use(contextmenu)
  app.use(loadingPlugin)
  app.use(apexCharts)

  /**
   * Register providers
   */
  app.provide('$echo', laravelEcho)
  app.provide('$pusher', pusher)

  /**
   * Register global components
   */
  app.component('VSelect', vSelect)

  // One `storage` listener per tab so a logout in any other same-origin tab
  // signs this one out instantly (cross-tab logout sync).
  registerCrossTabLogoutListener()

  return app
}

// Export the initialization function
export const initApp = initializeApp()
export { router }
